export const serif = "'Cormorant Garamond', Georgia, serif"
export const warm900 = '#3d2a0a'
export const warm700 = '#6b4f2e'
export const warm500 = '#9a7249'
export const warm300 = '#c4a882'
export const cream   = '#faf6ef'
export const stone   = '#e8dece'
export const textMuted = '#6b5d4f'
export const stoneTwo  = '#b0a090'
